module.exports = __webpack_public_path__ + "assets/txtsizeauto.723b4082.svg";